/**
 * matomo.js — Matomo, erst nach erteiltem Cookie-Consent
 * ---------------------------------------------------------------------------
 * Der Tracker wird NICHT beim Seitenaufbau geladen. Erst wenn Shopifys
 * Consent-API meldet, dass Analytics erlaubt ist, laeuft der
 * Original-Tracking-Code der Matomo-Installation los. Sagt der Besucher nein,
 * wird nie eine Anfrage an ulreich.at gestellt und kein Matomo-Cookie
 * (_pk_id / _pk_ses) gesetzt.
 *
 * Der Block in loadMatomo() ist der vom Kunden gelieferte Code, unveraendert
 * — gleiche Aufrufe, gleiche Reihenfolge, gleiche Werte (Instanz-URL,
 * Site-ID 3). Geaendert ist nur der ZEITPUNKT der Ausfuehrung. Wer den Code
 * aus Matomo neu holt, ersetzt genau diesen Block.
 *
 * Gleiche Mechanik wie assets/gtm.js: Datenquelle ist ausschliesslich
 * Shopifys eigenes Consent-Banner (Admin -> Kundenberechtigungen). Marketing
 * und Preferences interessieren hier nicht — Matomo ist Reichweitenmessung,
 * also haengt es an analyticsProcessingAllowed().
 */

(() => {
  "use strict";

  var loaded = false;

  function loadMatomo() {
    if (loaded) return;
    loaded = true;

    /* ---- Original-Tracking-Code (Matomo, Site-ID 3) — unveraendert ------- */
    var _paq = (window._paq = window._paq || []);
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
      var u = "https://www.ulreich.at/analytics/";
      _paq.push(["setTrackerUrl", u + "matomo.php"]);
      _paq.push(["setSiteId", "3"]);
      var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.async = true;
      g.src = u + "matomo.js";
      s.parentNode.insertBefore(g, s);
    })();
    /* ---- Ende Original-Tracking-Code ------------------------------------- */
  }

  /**
   * Aktueller Zustand aus der Consent-API. Gibt in Regionen ohne
   * Banner-Pflicht true zurueck — das ist Shopifys Regel, nicht unsere.
   */
  function analyticsAllowed() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.analyticsProcessingAllowed !== "function") return null;
    return api.analyticsProcessingAllowed();
  }

  // Spaetere Entscheidung im Banner (annehmen, ablehnen, Einstellungen
  // speichern) — Shopify feuert das Event bei jeder Aenderung. Ein Widerruf
  // kann den bereits geladenen Tracker nicht zurueckholen; ab dem naechsten
  // Seitenaufruf laedt er dann nicht mehr.
  document.addEventListener("visitorConsentCollected", function (event) {
    var detail = event.detail || {};
    if (detail.analyticsAllowed) loadMatomo();
  });

  // Bereits erteilter Consent aus einem frueheren Besuch: die API muss dafuer
  // geladen sein. Sie kommt ueber content_for_header, ist bei einem deferten
  // Skript also normalerweise schon da — der Fallback deckt den Rest ab.
  var attempts = 0;
  function withPrivacyApi() {
    var allowed = analyticsAllowed();
    if (allowed !== null) {
      if (allowed) loadMatomo();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
        if (error) return;
        if (analyticsAllowed()) loadMatomo();
      });
      return;
    }
    // Shopify-Objekt noch nicht da (sehr frueher Aufruf): kurz nachfassen.
    if (attempts++ < 20) window.setTimeout(withPrivacyApi, 250);
  }

  withPrivacyApi();
})();
